import {SettingsRowValue} from "../../common/CustomTable/CustomTable";
import React, {useRef, useState} from "react";
import {useTranslation} from "react-i18next";
import HTMLTextInput from "../../common/HTMLTextInput/HTMLTextInput";
import {useClearOnFirstCallback, useInputHandler, useUpdateHandler} from "../../../utilities/formHooks";
import Form, {FormFooter, FormHeader} from "../../common/Form/Form";
import Text from "../../common/Text/Text";
import {capitalize, lowerCaseFirstLetter} from "../../../utilities/helperFunctions";


function UsernamePasswordUserCredentialFormBody(props) {
    const {t} = useTranslation(['thirdPartyService', 'common']);
    const {
        type,
        thirdPartyService,
        SettingRows,
        onClose,
        isDisabled
    } = props;


    const passwordRef = useRef({});
    const clearOnFirstCallback = useClearOnFirstCallback();
    const [state, setState] = useState({
        username: ''
    });

    const updateHandler = useUpdateHandler({
        updateState: setState,
        passwordOptions: {
            'password': {
                ref: passwordRef,
                resetNames: ['username']
            }
        }
    });
    const inputHandler = useInputHandler({
        updateHandler
    });

    function onLogin() {
        props.onLogin({
            type,
            username: state.username,
            password: passwordRef.current.value
        });
    }

    const camelCaseType = lowerCaseFirstLetter(thirdPartyService.type);
    const isLoginEnabled = !!(state.username && passwordRef.current.value);

    return (
        <Form onClose={onClose} width={'35rem'} isDisabled={isDisabled}
            header={
                <FormHeader text={t(`thirdPartyService:option.signIn${capitalize(thirdPartyService.authenticationScope)}`)}
                    iconName={`${camelCaseType}UserSignIn`} isDisabled={isDisabled}/>
            }
            body={
                <form onSubmit={onLogin} style={{paddingTop: '0.5rem', paddingBottom: '0.25rem'}}>
                    <div className="settings-table">
                        <div className="table-row-group">
                            <SettingsRowValue label={t(`thirdPartyService:label.${camelCaseType}`)} value={thirdPartyService.name}
                                isTight isDisabled={isDisabled}/>

                            {SettingRows &&
                                <SettingRows thirdPartyService={thirdPartyService} isDisabled={isDisabled}/>
                            }
                        </div>
                    </div>

                    <div className="display-input">
                        <Text value={t('thirdPartyService:label.credentials')} style={{marginBottom: '0.25rem'}}
                            isDisabled={isDisabled}/>

                        <HTMLTextInput name={'username'} value={state.username} onChange={inputHandler}
                            placeholder={t('common:label.username')} autoComplete={`${camelCaseType}Username`} isDisabled={isDisabled}/>
                    </div>

                    <div className="display-input">
                        <HTMLTextInput name={'password'} type={'password'} inputRef={passwordRef} onChange={inputHandler}
                            placeholder={t('common:label.password')} autoComplete={`${camelCaseType}Password`}
                            onBeforeInput={clearOnFirstCallback} isDisabled={isDisabled}/>
                    </div>

                    <button type="submit" hidden disabled={!isLoginEnabled}/>
                </form>
            }
            footer={
                <FormFooter addText={t('thirdPartyService:option.signIn')} onAddClick={onLogin}
                    onCancel={onClose} isAddEnabled={isLoginEnabled} isDisabled={isDisabled}
                />
            }
        />
    )
}

export default UsernamePasswordUserCredentialFormBody;
